export const policies = {
    VISIT_OMC_APP: 'visit_omc_app',
    VISIT_B2C_PLATFORM: 'visit_b2c_platform',
    VISIT_EC_PLATFORM: 'visit_ec_platform',
    VISIT_B2B_TW_PLATFORM: 'visit_b2b_tw_platform',
    VISIT_WIDGETS: 'visit_widgets',
    VISIT_INVOICE_MANAGEMENT_PAGE: 'visit_invoice_management_page',
    VISIT_WAREHOUSE_MANAGEMENT_PAGE: 'visit_warehouse_management_page',
    VISIT_TIPTOP_UPLOAD_PAGE: 'visit_tiptop_upload_page',
    VISIT_FAST_MOVEMENT_PAGE: 'visit_fast_movement_page',
    VISIT_TRACKING_NUMBER_SETTING_PAGE: 'visit_tracking_number_setting_page',
    VISIT_FINANCIAL_FILES_DOWNLOAD_PAGE: 'visit_financial_files_download_page',
    VISIT_SHIPMENT_LOGISTIC_CONSOLE_PAGE: 'visit_shipment_logistic_console_page',
    VISIT_SHIPMENT_LABELS_PAGE: 'visit_shipment_labels_page',
    VISIT_SHIPMENT_RETURN_LOGISTIC_PAGE: 'visit_shipment_return_logistic_page',
    VISIT_SHIPMENT_RETURN_AND_REFUND_PAGE: 'visit_shipment_return_and_refund',
    ACCEPTANCE_SHIPMENT_RETURN_PACKAGES: 'omc-shipment_return-acceptance_packages',
    UPDATE_SHIPMENT_RETURN_ESTIMATED_REFUND_DATE: 'omc-shipment_return-update_estimated_refund_date',
    UPDATE_SHIPMENT_RETURN_REFUND_AMOUNT: 'omc-shipment_return-update_refund_amount',
    UPDATE_SHIPMENT_RETURN_PACKAGE_NUMBER: 'omc-shipment_return-update_package_number',
    UPDATE_SHIPMENT_RETURN_NOTES: 'omc-shipment_return-update_notes',
    UPDATE_SHIPMENT_RETURN_RETURN_CHANNEL: 'omc-shipment_return-update_return_channel',
    DOWNLOAD_SHIPPING_LABEL: 'download_shipping_label',
    DOWNLOAD_SHIPPING_INVOICE: 'download_shipping_invoice',
    DOWNLOAD_SHIPPING_LIST: 'download_shipping_list',
    DOWNLOAD_SG_INVOICE: 'download_sg_invoice',
    SEND_SG_INVOICE: 'send_sg_invoice',
    UPDATE_STORE_INFO: 'update_store_info',
    CANCEL_ORDER: 'cancel_order',
    USE_DEVELOPMENT_FEATURE: "useDevelopmentFeature",
    BUILD_TT_ORDER: 'build_tt_order',
    DOWNLOAD_CCID: 'download_ccid',
    REGENERATE_DESIGN_PRINT: 'regenerate_design_print',
    VALIDATE_PERSONALIZE: 'validate_personalize',
    EDIT_COLLABORATION_SETTING: 'edit_collaboration_setting',
    VIEW_COLLABORATION_HISTORY: 'view_collaboration_history',
    MANAGE_RESERVED_SKU_INFO: 'manage_reserved_sku_info',
    EDIT_RETURN_REASONS: 'edit_return_reasons',
    CAN_ACCESS_DRAFT_ORDER_BUILDER: 'can_access_draft_order_builder',
    CAN_ACCESS_HEIMAO_LABEL_GENERATOR: 'can_access_heimao_label_generator',
    CAN_ACCESS_WIDGET_UPDATE_TRACKING_NUMBERS: 'can_access_widget_update_tracking_numbers',
}
